import {
    collection,
    component,
    EntityData,
    EntityModel,
    FedeltaImageData,
    field,
    identifier,
    transientField
} from "@fedelta-pos/data-client";
import {inject, Injectable, Injector} from "@angular/core";
import {OrderType} from '../order/order';

// noinspection JSUnusedGlobalSymbols
export enum DealAvailability {
    AVAILABLE = "AVAILABLE",
    INVALID = "INVALID",
    EXPIRED = "EXPIRED",
    CONSUMED = "CONSUMED",
    DISCONTINUED = "DISCONTINUED",
    UNAVAILABLE_AT_STORE = "UNAVAILABLE_AT_STORE",
    UNSCHEDULED_AT_STORE = "UNSCHEDULED_AT_STORE",
    BEFORE_VALID_PERIOD = "BEFORE_VALID_PERIOD",
    OUTSIDE_WEEKDAY_TIME_RESTRICTION = "OUTSIDE_WEEKDAY_TIME_RESTRICTION"
}

export class DealDiscountData extends EntityData<DealDiscountData> {
    @identifier discountId: number;
    @field name: string;
    @field description: string;
    @field accessibleOutlets: number[];
}

export class DealMixAndMatchData extends EntityData<DealMixAndMatchData> {
    @identifier id: number;
    @field name: string;
    @field description: string;
    @field accessibleOutlets: number[];
}

export class DealSellableData extends EntityData<DealSellableData> {
    @identifier sellableId: number;
    @field name: string;
    @field description: string;
    @field externalDescription: string;
}

export class DealProductData extends EntityData<DealProductData> {
    @field quantity: number;
    @component sellable: DealSellableData;
}

export class DealTemplateData extends EntityData<DealTemplateData> {
    @component image: FedeltaImageData;
    @field imageAutoCrop: boolean;
}

export class DealData extends EntityData<DealData> {
    @identifier id: string;
    @field integratedDealConfigId: number;
    @field providerName: string;
    @field name: string;
    @field dealCode: string;
    @field issueDate: Date;
    @field expiryDate: Date;
    @field usageLimit: number;
    @field usageCount: number;
    @field status: string;
    @field appId: number;
    @field scheduleRequired: boolean;
    @field showAppDealCard: boolean;
    @field selectByDealCodeInApp: boolean;
    @field featureOnAppMenu: boolean;
    @field suppressDealCardIfAnyOrdered: boolean;
    @field suppressDealCardIfOrdered: boolean;
    @field showAppQrCode: boolean;
    @field orderAhead: boolean;
    @field orderDelivery: boolean;
    @field orderAtTable: boolean;
    @field memberDeal: boolean;
    @component image: FedeltaImageData;
    @field imageAutoCrop: boolean;
    @field title: string;
    @field description: string;
    @field showTitleOnDealCard: boolean;
    @field showActionButtonOnDealCard: boolean;
    @component template: DealTemplateData;
    @component discount: DealDiscountData;
    @component mixAndMatch: DealMixAndMatchData;
    @collection(DealProductData) products: DealProductData[];
    @field theme: string;
    @field availability: DealAvailability;

    @transientField used: boolean;

    public get isTicket(): boolean {
        return (!this.discount || !this.discount.discountId) && (!this.mixAndMatch || !this.mixAndMatch.id) && (!this.products || !this.products.length);
    }

    // Deals are only available if they specify the order type.
    // If we don't know the order type, we allow any deal that specified at least one order type.
    // If the deal becomes invalid once the order type is selected, it will be removed.
    public isAvailableForOrderType(orderType: OrderType): boolean {
        return (!orderType && (this.orderAhead || this.orderDelivery || this.orderAtTable)) ||
            (orderType === OrderType.ORDER_AHEAD && this.orderAhead) ||
            (orderType === OrderType.ORDER_DELIVERY && this.orderDelivery) ||
            (orderType === OrderType.ORDER_AT_TABLE && this.orderAtTable);
    }
}

@Injectable()
export class DealEntityModel extends EntityModel<DealData> {
    constructor() {
        console.log("--- DealEntityModel");
        super(inject(Injector), DealData);
    }
}
